const MOBILE_EXCLUDED_SECTION_TITLES = new Set(["JS", "Dimensions"]);

const mergeItems = (defaultItems = [], savedItems = []) => {
  if (!defaultItems.length) return savedItems;
  if (!savedItems.length) return defaultItems;

  const result = savedItems.map((item) => ({ ...item }));
  const savedParams = new Set(result.map((item) => item.parameter).filter(Boolean));

  defaultItems.forEach((defaultItem, defaultIndex) => {
    if (!defaultItem.parameter || savedParams.has(defaultItem.parameter)) return;

    let insertAt = result.length;
    for (let i = defaultIndex - 1; i >= 0; i--) {
      const prevIndex = result.findIndex((item) => item.parameter === defaultItems[i].parameter);
      if (prevIndex !== -1) {
        insertAt = prevIndex + 1;
        break;
      }
    }

    result.splice(insertAt, 0, { ...defaultItem });
  });

  return result;
};

const mergeChildOptions = (defaultChildren = [], savedChildren = []) => {
  if (!defaultChildren.length) return savedChildren;
  if (!savedChildren.length) return defaultChildren;

  return defaultChildren.map((defaultChild) => {
    const savedChild = savedChildren.find(
      (child) => child.name === defaultChild.name || child.title === defaultChild.title
    );

    if (!savedChild) return { ...defaultChild };

    return {
      ...defaultChild,
      ...savedChild,
      items: mergeItems(defaultChild.items, savedChild.items),
    };
  });
};

export const mergeOptionsWithDefaults = (defaultOptions = [], savedOptions = []) => {
  if (!defaultOptions.length) return savedOptions;
  if (!savedOptions.length) return defaultOptions;

  return defaultOptions.map((defaultSection) => {
    const savedSection = savedOptions.find(
      (section) => section.name === defaultSection.name || section.title === defaultSection.title
    );

    if (!savedSection) return { ...defaultSection };

    return {
      ...defaultSection,
      ...savedSection,
      items: mergeItems(defaultSection.items, savedSection.items),
      collapseChildOptions: mergeChildOptions(
        defaultSection.collapseChildOptions,
        savedSection.collapseChildOptions
      ),
    };
  });
};

export const buildMobileOptionsFromDesktop = (desktopOptions = []) =>
  desktopOptions
    .filter((section) => !MOBILE_EXCLUDED_SECTION_TITLES.has(section.title))
    .map((section) => JSON.parse(JSON.stringify(section)));

export const buildMobileOptionsWithSaved = (desktopOptions = [], savedMobileOptions = []) =>
  mergeOptionsWithDefaults(
    buildMobileOptionsFromDesktop(desktopOptions),
    savedMobileOptions || []
  );
